import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import placeholder from "../../assets/placeholder-image.webp";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getIndiaPolltypes,
  getStatesConsistuency,
} from "../../redux/actions/pollingAction";
import PollSelectComp from "../../common/pollSelectComp";
import { handleSpaceInstatename } from "../../helpers/utilities";
import { getElectionType } from "../../redux/actions/privateApiAction";
function IndianPolls() {
  const location = useLocation();
  const isVerified = localStorage.getItem("accessToken");
  const country = localStorage.getItem("country");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { slug } = useParams();
  const { IndianStateResponse } = useSelector((state) => state.pollWeb);
  console.log("🚀 ~ IndianPolls ~ IndianStateResponse:", IndianStateResponse)

  useEffect(() => {
    // if (!isVerified) {
    //   navigate("/login");
    // }
    dispatch(getStatesConsistuency({ country: country }));
    dispatch(getElectionType(country));
  }, []);

  const [showState, setShowState] = useState(false);
  const [statePollName, setStatePollName] = useState("State");
    const [getLoggedIn, setGetLoggedIn] = useState();

  const { getElectionTypeResponse } = useSelector(
    (state) => state?.privateReducer
  );
  console.log("🚀 ~ IndianPolls ~ getElectionTypeResponse:", getElectionTypeResponse)
  const [hoveredId, setHoveredId] = useState(null);
  const [imageChange, setimageChange] = useState({
    id: null,
    isHover: "",
  });

  // const mapArray = [
  //   {
  //     id: 1,
  //     name: "Delhi Polls",
  //     map: grayDelhimap,
  //     hoverMap: delhimap,
  //     url: "/india-polls/delhi-polls",
  //   },
  // ];

  // console.log("IndianStateResponse", IndianStateResponse);

  const mapArray = IndianStateResponse?.filter(
    (d) => d?.state?.id && d?.state?.name
  )?.map((d) => {
    if (country == 233) {
      return {
        id: d?.state?.id,
        countryId: d?.countryConstituency?.country_Id,
        name: d?.state?.name,
        map: d.icon || placeholder,
        hoverMap: d.hoverIcon || placeholder,
        url: `/us-poll/${handleSpaceInstatename(d?.state?.name)}-polls`,
        // url: `/${d?.countryConstituency?.name}-polls/${handleSpaceInstatename(
        //   d?.state?.name
        // )}-polls`,
      };
    } else {
      return {
        id: d?.state?.id,
        countryId: d?.countryConstituency?.country_Id,
        name: d?.state?.name,
        map: d.icon || placeholder,
        hoverMap: d.hoverIcon || placeholder,
        url: `/${slug}/polls/${handleSpaceInstatename(d?.state?.name)}-polls`,
        // url: `/${d?.countryConstituency?.name}-polls/${handleSpaceInstatename(
        //   d?.state?.name
        // )}-polls`,
      };
    }
  });
  console.log("🚀 ~ IndianPolls ~ mapArray:", mapArray)
  useEffect(() => {
    const isVerified = localStorage.getItem("accessToken");
    setGetLoggedIn(isVerified);
  }, []);
  const handleTypeSelection = (type) => {
    setShowState(type.level !== "National");
    const countryName = type?.country?.name?.toLowerCase().replace(/\s+/g, "-");
    if (type.level === "National") {
      if (country == 233) {
        navigate(`/us-poll/${countryName}-polls?type=${type.level}`);
      } else {
        navigate(`/${slug}/polls/${countryName}-polls?type=${type.level}`);
      }
    } else {
      setStatePollName(type?.name);
    }
  };

  return (
    <>
      <div className="bg_home flex flex-col pb-8">
        <div className="flex flex-row px-6 md:px-40 gap-4 text-[12px] font-semibold bg-[#E2E7EE]">
          <Link
            to={`/${slug}/general-stories`}
            className={`py-2 nav-link-hover-poll ${
              location.pathname === `/${slug}/general-stories`
                ? "font-bold current-page"
                : "text-[#7F8FA4]"
            }`}
          >
            General Stories
          </Link>
          <Link
            to={`/${slug}/polling`}
            className={`py-2 ${
              location.pathname === `/${slug}/polling`
                ? "font-bold current-page"
                : "text-[#7F8FA4]"
            }`}
          >
            Polls
          </Link>
          {getLoggedIn !== null && getLoggedIn !== undefined ? (
          <Link
            to={`/${slug}/predictions_post`}
            className={`py-2 nav-link-hover-poll ${
              location.pathname === `/${slug}/prediction`
                ? "font-bold current-page"
                : "text-[#7F8FA4]"
            }`}
          >
            Predictions
          </Link>) : (
             <Link
                to="/login"
                className={`py-2 nav-link-hover-poll ${
                  location.pathname === "/login"
                    ? "font-bold"
                    : "text-[#7F8FA4]"
                }`}
              >
                Predictions
              </Link>
            )}
        </div>
        <div className="bg_home md:bg-[#F7F8FA] px-4  md:px-40 flex flex-col pb-6 md:py-5">
          <div className="bg-white w-full rounded-xl shadow-sm p-3 md:p-5   md:block">
            {/* <div className=" h-auto pb-14 ">
              <div className="text-[20px] text-[#7F8FA4]">Lok Sabha Polls</div>
              <div className="my-2">
                <div className="m-auto  min-[380px]:m-0 size-[160px] bg-[#F7F8FA] cursor-pointer rounded-xl flex justify-center items-center flex-col">
                  <img src={IndianFlag} alt="indian-flag" />
                  <p className="mt-5 text-[12px] font-semibold">India Polls</p>
                </div>
              </div>
            </div> */}
            <>
              {/* Election Type Selection */}
              <p className="my-5 text-[21px] font-semibold">
                Select Election Type
              </p>
              {/* Election Type Cards */}
              <div className="my-2 grid grid-cols-1 min-[380px]:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-2">
                {getElectionTypeResponse?.data?.map((type, index) => (
                  <div
                    key={type?.id}
                    className={`m-auto min-[380px]:m-0 size-[160px] hover:bg-white bg-[#F7F8FA] hover:border-2 border-red-500 cursor-pointer rounded-xl flex justify-center items-center flex-col ${
                      !type?.isActive && "hidden"
                    }`}
                    onClick={() => handleTypeSelection(type)}
                  >
                    <img src={type.image} alt={type.name} width={80} />
                    <p className="mt-5 text-[12px] font-semibold">
                      {type.name}
                    </p>
                  </div>
                ))}
              </div>
            </>
            {showState && (
              <div className=" h-auto pb-14 ">
                <div className="text-[20px] text-[#7F8FA4]">
                  {statePollName} Polls
                  {/* Vidhan Sabha Polls */}
                </div>
                <PollSelectComp mapArray={mapArray} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default IndianPolls;
